import React, { useState } from 'react'
import { FlexColumn } from '@/atoms/FlexContainers'
import { Image } from '@/atoms/Image'
import { CaptionSM, HeadingXS, Text, TitleXS, TitleXXS } from '@/atoms/Text'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { useTheatricalPromotionContext } from '@/views/TicketCheckoutViews/ShowtimesView/components/TheatricalPromotionContext'
import { FlexibleBookingToolTip } from '@/views/TicketCheckoutViews/ShowtimesView/components/ToolTips/FlexibleBookingToolTip'
import { SpecificTimesToolTip } from '@/views/TicketCheckoutViews/ShowtimesView/components/ToolTips/SpecificTimesToolTip'
import { NoFeesValuesType } from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/config/NoFeesValues'

const BANNER_CONFIGS = {
  desktop: {
    videoStyles: 'z-[9] right-0',
  },
  tablet: {
    videoStyles: 'z-10 -right-[2em]',
  },
  mobile: {
    videoStyles: 'z-10 -right-[4em]',
  },
}
export const LargeContent = ({ code, bannerValues }: { code: string; bannerValues: NoFeesValuesType }) => {
  const config = BANNER_CONFIGS['desktop']
  const { t } = useTranslate('tickets')
  const [videoFailed, setVideoFailed] = useState(false)
  const { experiments } = useTheatricalPromotionContext()
  const tkokNoFeesExp = experiments ? experiments['tkok-nofees-video'] : undefined
  const handleVideoError = () => {
    setVideoFailed(true)
  }
  return (
    <div className="relative mb-2 rounded-xl bg-[#bce3ea]">
      <div className=" relative h-full min-h-[160px] w-full rounded-xl @container/banner lg:!min-h-[140px]">
        <div className={'relative z-0 h-full min-h-[160px] overflow-hidden  rounded-r-xl lg:!min-h-[140px]'}>
          <div className={'absolute left-0 top-0 z-10   h-[160px] w-full min-w-[200px] lg:!h-[140px]'}>
            <div className={'relative flex w-full justify-end'}>
              <div className="relative right-0 top-0 z-10 block  h-[160px] w-[72px] bg-gradient-to-r from-[#bce3ea]  to-transparent to-100% lg:!h-[140px] " />
              <div className="w-[250px] lg:w-[215px]" />
            </div>
          </div>
          {tkokNoFeesExp && !videoFailed ? (
            <video
              preload="auto"
              className={`${config.videoStyles} absolute -top-[10%] right-0 h-[110%] w-auto rounded-xl object-contain `}
              autoPlay
              loop
              muted
              playsInline
              onError={handleVideoError}
              src={bannerValues.video}
            />
          ) : (
            <Image
              src={bannerValues.image || ''}
              className={`${config.videoStyles} absolute !-right-[1.5em] top-[30%] h-[70%] w-auto rounded-xl object-contain  pr-1 @md:top-0 @md:h-[100%] @lg:-top-[5%] @lg:h-[110%] @xl:!right-0 @4xl:pr-6 `}
              width={200}
              height={200}
              alt={''}
            />
          )}
        </div>
        {/* Main content container - absolute positioning to fill parent */}
        <div className="absolute inset-0 z-10 flex w-[66%] min-w-[600px] items-stretch justify-between rounded-xl px-0 @container/content">
          {/*LEFT TEXT*/}
          <FlexColumn className="flex w-[33%] min-w-[335px]  justify-center py-2  pl-6">
            <div className={'w-[165px] @md:w-[200px] @lg:w-[100%]'}>
              {tkokNoFeesExp ? (
                <>
                  <HeadingXS
                    className=" relative text-xl leading-6 @md:!text-2xl @md:leading-7 "
                    weight="bold"
                    color="black"
                  >
                    <Translate i18nKey="theatersaresellingout" t={t}>
                      Theaters Are Selling Out!
                    </Translate>
                  </HeadingXS>
                  <TitleXXS color="core-gray-700">
                    <Translate i18nKey="noonlinefeeswhenbookingtoday" t={t}>
                      No online fees when you book today!
                    </Translate>
                  </TitleXXS>
                </>
              ) : (
                <HeadingXS
                  className=" relative text-xl leading-6 @md:!text-2xl @md:leading-7 "
                  weight="bold"
                  color="black"
                >
                  <Translate i18nKey="noOnlineFeesNoHassle" t={t}>
                    No Online Fees. <span>No Hassle.</span>
                  </Translate>
                </HeadingXS>
              )}
              <div className="z-[70] pt-1">
                <SpecificTimesToolTip buttonClassName="!px-0" buttonColor={'black'}>
                  <TitleXS color="black">{t('onSelectShowtimes', 'On Select Showtimes')}</TitleXS>
                </SpecificTimesToolTip>
                <FlexibleBookingToolTip
                  className="mt-2"
                  buttonColor={'black'}
                  buttonClassName="bg-black/10 border-none text-black focus-visible:outline-none focus-visible:ring-offset-transparent focus-visible:ring-transparent backdrop-blur-[24px] !backdrop-filter"
                />
              </div>
            </div>
          </FlexColumn>
          {/*{BUTTON}*/}
          <FlexColumn className="flex w-[33%] min-w-[265px] items-start  justify-center">
            <div className={'text-center'}>
              <Text className="photon-eyebrow-sm @md/content:!photon-eyebrow-md text-black" weight="semibold">
                {t('usePromoCode', 'Use Promo Code')}
              </Text>
              <div className={'my-2 justify-center'}>
                <span className=" bg-[#EA3358] px-3 py-2 font-bold text-white">{code || 'NOFEES'}</span>
              </div>
              <Text className="photon-eyebrow-sm @md/content:!photon-eyebrow-md text-black " weight="semibold">
                {t('atCheckout', 'At Checkout')}
              </Text>
              <CaptionSM
                color="core-gray-500"
                italic
                className="mt-1 text-center @md:text-left @xl/content:mt-0 @xl/content:text-center"
              >
                {t('angelPartneringTheaters', 'Available for Angel Partnering Theaters.')}
              </CaptionSM>
            </div>
          </FlexColumn>
        </div>
      </div>
    </div>
  )
}
